import { useSelector } from 'react-redux';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { RoutePath } from '@constants/routes';

const AuthRoute = ({ component: Component, ...rest }) => {
    const { state } = useLocation();
    const user = useSelector(state => state.auth.user);

    if (user) {
        if (user?.onboardingCompleted) {
            return <Redirect to={RoutePath.Home} />;
        }
        const onboardingAfterGoogle =
            state?.from?.pathname === RoutePath.Onboarding && !!state?.from?.search ? state?.from?.search : '';
        if (!user?.onboardingCompleted) {
            return <Redirect to={`${RoutePath.Onboarding}${onboardingAfterGoogle}`} />;
        }
    }

    return <Route {...rest} render={props => <Component {...props} />} />;
};

export default AuthRoute;
